import axios from 'axios'
import type { AxiosInstance, AxiosError } from 'axios'

// Criar instância do axios
const api: AxiosInstance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para adicionar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('kardapio-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Não redirecionar se for erro de login (para mostrar mensagem na tela)
    const isLoginRequest = error.config?.url?.includes('/auth/login')
    
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('kardapio-token')
      localStorage.removeItem('kardapio-refresh-token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
